import { apiClient } from 'utils/apiClient';
import { ApiEndpoints } from 'models/apiEndpoints';
import { isResponseError, TResponse } from 'models/apiClient';
import {
  ESize,
  IEntryData,
  IGaleryData,
  IGaleryRequest,
  IGaleryValidationResult,
  IPhotoUpload,
} from 'models/galery';
import { RequestHeaderKeyTypes, RequestHeaderValueTypes } from 'constants/RequestHeaderTypes';

export const getGallery = async (ownerObjectId: string, withPhoto?: boolean) => {
  const { data } = withPhoto
    ? await apiClient.get<TResponse<IGaleryData>>(
        ApiEndpoints.GET_GALLERY_OWNER_FILES(ownerObjectId),
      )
    : await apiClient.get<TResponse<IGaleryData>>(
        ApiEndpoints.GET_GALLERY_OWNER(ownerObjectId),
      );
  if (isResponseError(data)) {
    return null;
  }
  return data;
};

export const getGalleryWithLicences = async (ownerObjectId: string) => {
  const { data } = await apiClient.get<TResponse<IGaleryData>>(
    ApiEndpoints.GET_GALLERY_LE_OWNER(ownerObjectId),
  );
  if (isResponseError(data)) {
    return null;
  }
  return data;
};
export const getGalleryMain = async (ownerObjectId: string) => {
  const { data } = await apiClient.get<TResponse<IEntryData>>(
    ApiEndpoints.GET_GALLERY_MAIN_OWNER(ownerObjectId),
  );
  if (isResponseError(data)) {
    return null;
  }
  return data;
};

export const getGalleryPreview = async (id: string, size: ESize) => {
  try {
    const { data } = await apiClient.get(
      `${ApiEndpoints.GET_GALLERY_PREVIEW(id)}?size=${size}`,
    );
    if (isResponseError(data) || !data?.url) {
      return null;
    }
    return data.url;
  } catch (e) {
    return null;
  }
};

export const getGalleryMainPreview = async (id: string, size: ESize) => {
  const { data } = await apiClient.get(
    `${ApiEndpoints.GET_GALLERY_MAIN_PREVIEW(id)}?size=${size}`,
  );
  if (isResponseError(data) || !data?.url) {
    return null;
  }

  return data.url;
};

export const validateGalleryImage = async (file: File): Promise<IGaleryValidationResult> => {
  const formData = new FormData();
  formData.append('newGalleryEntry', file, file.name);

  const { data } = await apiClient.post<TResponse<IGaleryValidationResult>>(
    ApiEndpoints.VALIDATE_GALLERY_IMAGE(),
    formData,
    {
      headers: {
        [RequestHeaderKeyTypes.CONTENT_TYPE]: RequestHeaderValueTypes.MULTIPART_FORM_DATA,
      },
    },
  );

  if (isResponseError(data)) {
    return { warnings: [] };
  }

  return data;
};

export const updateGallery = async (
  id: string,
  parameters: IGaleryRequest,
  files: IPhotoUpload,
): Promise<any> => {
  const config = {
    headers: {
      [RequestHeaderKeyTypes.CONTENT_TYPE]: RequestHeaderValueTypes.MULTIPART_FORM_DATA,
    },
    timeout: 0,
  };
  const formData = new FormData();

  formData.append(
    'parameters',
    new Blob([JSON.stringify(parameters)], {
      type: 'application/json',
    }),
  );

  if (files) {
    const keys = Object.keys(files);
    keys.map((key) => {
      formData.append('newGalleryEntries', files[key], key);
    });
  }

  const { data } = await apiClient.put(
    ApiEndpoints.UPDATE_GALLERY_OWNER(id),
    formData,
    config,
  );
  if (isResponseError(data)) {
    return null;
  }
  return data;
};

export const downloadGalleryPreview = async (entryId: string, size: ESize): Promise<any> => {
  const response = await apiClient.get(
    `${ApiEndpoints.DOWNLOAD_GALLERY_PREVIEW(entryId)}?size=${size}`,
  );

  if (response.status !== 200) {
    return null;
  }

  return response.data.url;
};
